module.exports = __webpack_public_path__ + "static/media/ic_location_pin.5e922901.svg";